var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
          name: 'Dashboard',
          icon: 'ni ni-shop text-orange',
          path: '/',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Clientes',
          icon: 'ni ni-single-02 text-orange',
        }}},[_c('sidebar-item',{attrs:{"link":{ name: 'Top Clientes', path: '/pricing' }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Lista de Clientes',
            path: '/clientes/lista-clientes',
          }}}),_c('sidebar-item',{attrs:{"link":{ name: 'Grupos de Clientes', path: '/register' }}})],1)],1)],2),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }